module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var a = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      r.d(n, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 2);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("react-dom/server");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(0),
      a = r(1);

  var o = function o(e) {
    return "string" == typeof e ? e : Object(a.renderToStaticMarkup)(e);
  },
      i = function i(e, t) {
    var r = {};

    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var a = 0;

      for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) {
        t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
      }
    }

    return r;
  };

  var s = function s(e) {
    var t = e.penTitle,
        r = e.embedHeight,
        a = e.themeId,
        s = e.editable,
        c = e.description,
        l = e.tags,
        u = e.htmlClasses,
        d = e.stylesheets,
        p = e.scripts,
        f = e.head,
        _e$defaultTabs = e.defaultTabs,
        b = _e$defaultTabs === void 0 ? ["result"] : _e$defaultTabs,
        y = e.prefillData,
        m = e.children,
        _e$className = e.className,
        O = _e$className === void 0 ? "codepen" : _e$className,
        g = i(e, ["penTitle", "embedHeight", "themeId", "editable", "description", "tags", "htmlClasses", "stylesheets", "scripts", "head", "defaultTabs", "prefillData", "children", "className"]);
    var h = JSON.stringify(Object.assign({
      description: c,
      head: o(f),
      html_classes: u,
      scripts: p,
      stylesheets: d,
      tags: l,
      title: t
    }, y));
    return n.createElement("div", Object.assign({
      className: O,
      "data-prefill": h,
      "data-height": r,
      "data-theme-id": a,
      "data-editable": "".concat(s),
      "data-default-tab": b.join(",")
    }, g), m);
  },
      c = function c(e, t) {
    var r = {};

    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var a = 0;

      for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) {
        t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
      }
    }

    return r;
  };

  var l = function l(e) {
    var t = e.lang,
        r = e.children,
        a = c(e, ["lang", "children"]);
    return n.createElement("pre", Object.assign({
      "data-lang": t
    }, a), o(r));
  };

  var u = function u(e) {
    var t = e.join("").replace(/^\n/, "").replace(/\n$/, "").split("\n"),
        r = t[0].match(/^\s+/);
    if (!r) return t.join("\n");
    var n = r[0],
        a = new RegExp("^".concat(n));
    return t.map(function (e) {
      return e.replace(a, "");
    }).join("\n");
  };

  var d = {
    async: !0
  };

  var p = function p(e) {
    var t = Object.assign({}, d, e);
    Object(n.useEffect)(function () {
      var e = window.hasOwnProperty("__CPEmbed"),
          r = Boolean(document.getElementById("__react-codepen-prefill-embed"));
      if (e || r) return;
      var n = document.createElement("script"),
          a = t.async,
          o = t.srcOverride;
      a && n.setAttribute("async", "true"), n.setAttribute("src", o || "https://static.codepen.io/assets/embed/ei.js"), n.setAttribute("id", "__react-codepen-prefill-embed"), document.body.appendChild(n);
    });
  };

  r.d(t, "PrefillEmbed", function () {
    return s;
  }), r.d(t, "PrefillLang", function () {
    return l;
  }), r.d(t, "stripIndent", function () {
    return u;
  }), r.d(t, "useCodePenEmbed", function () {
    return p;
  });
}]);